import Specialist from "./components/Specialist.vue";
import SpecialistDashboard from "./components/SpecialistDashboard.vue";
import SpecialistCompare from "./components/SpecialistCompare.vue";
import landingPage from "./components/landingPage";
import Register from "./components/Register";
import loginPage from "./components/loginPage";
import DashboardSetting from "./components/DashboardSetting.vue";
import Dummy from "./components/Dummy.vue";
import HubSystem from "./components/HubSystem";
import ApplicationSystem from "./components/ApplicationSystem";
import ReportsStatistics from "./components/ReportsStatistics";
import ConfigureReport from "./components/ConfigureReport";
import AboutUs from "./components/AboutUs.vue";
import UserManagePage from "./components/UserManagePage.vue";
import RolesPage from "./components/RolesPage.vue";
import SearchAppAdminApps from "./components/SearchAppAdminApps.vue";
import ViewAppAdminApps from "./components/ViewAppAdminApps.vue";
import ViewAllApplications from "./components/ViewAllApplications.vue";
import CloneApplication from "./components/CloneApplication";
import NewApplicationCard from "./components/NewApplicationCard.vue";
import ApplicationConfig from "./components/ApplicationConfig.vue";
import TestAppMenu from "./components/TestAppMenu.vue";
import AppTester from "./components/AppTester";
import Dashboard from "./components/Dashboard.vue";
import Activities from "./components/Activities.vue";
import ApplicationPage from "./components/ApplicationPage.vue";
import AppUsuage from "./components/AppUsuage.vue";
import AppUsuageReport from "./components/AppUsuageReport.vue";
import ForgotPasword from "./components/ForgotPasword.vue";
import ActivityChildView from "./components/ActivityChildView.vue";
import SpecialistPatientsStudents from "./components/SpecialistPatientsStudents.vue"
import SpecialistGoals from "./components/SpecialistGoals.vue"
import Screening from "./components/Screening.vue";
import Assessment from "./components/Assessment.vue";
import Intervention from "./components/Intervention.vue";
import InterventionPlan from "./components/SpecialistInterventionPlan.vue";
import SpecialistDashboards from "./components/SpecialistDashboards.vue";
import SpecialistGoalsChildScreening from "./components/SpecialistGoalsChildScreening.vue";
import SpecialistDashboardInsights from "./components/SpecialistDashboardInsights.vue";
import SpecialistStatisticsIndividual from "./components/SpecialistStatisticsIndividual.vue";
import SpecialistStatisticsAll from "./components/SpecialistStatisticsAll.vue";
import SpecialistDashboardAnalytics from "./components/SpecialistDashboardAnalytics.vue";
import DataPipelineTool from "./components/DataPipelineTool.vue";
import OrganizationDashboardAnalytics from "./components/OrganizationDashboardAnalytics.vue";
import OrganizationDashboardInsights from "./components/OrganizationDashboardInsights.vue";
import OrganizationSchools from "./components/OrganizationSchools.vue";
import OrganizationSpecialists from "./components/OrganizationSpecialists.vue";
import OrganizationSchoolsGraphs from "./components/OrganizationSchoolsGraphs.vue";
import OrganizationIndividualSchool from "./components/OrganizationIndividualSchool.vue";
import OrganizationIndividualSpecialist from "./components/OrganizationIndividualSpecialist.vue";
import OrganizationManagement from "./components/OrganizationManagement.vue";
import Calendar from "./components/Calendar.vue";

export default [
  { 
    path: "/", name: "landingPage", component: landingPage, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true } 
  },
  { 
    name: "Specialist", path: "/specialist", component: Specialist, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true } 
  },
  { 
    name: "SpecialistDashboard", path: "/specialistDashboard", component: SpecialistDashboard, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    name: "SpecialistCompare", path: "/specialistCompare", component: SpecialistCompare, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    name: "Register", path: "/register", component: Register, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    name: "ForgotPasword", path: "/forgot-password", component: ForgotPasword, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    name: "Login", path: "/login", component: loginPage, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/dashboardSetting", component: DashboardSetting, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/pageNotAvailable", component: Dummy, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/aboutUs", component: AboutUs, 
    meta: { requiresAuth: false, showFooter: true, showHeader: true }
  },
  { 
    path: "/userManagePage", component: UserManagePage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage", name:"rolesPage", component: RolesPage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/viewAllApplications", name:"viewAllApplications", component: ViewAllApplications, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps", name:"searchAppAdminApps", component: SearchAppAdminApps, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps", name:"viewAppAdminApps", component: ViewAppAdminApps, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/cloneAppName", name:"cloneApp", component: CloneApplication, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard", name:"NewAppCard", component: NewApplicationCard, 
    meta: { requiresAuth: true, showFooter: false, showHeader: false }
  },
  { 
    path: "/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/:applicationID", name:"ApplicationConfig", component: ApplicationConfig, 
    meta: { requiresAuth: true, showFooter: false, showHeader: false }
  },
  { 
    path: "/individualReport/:reportID", name: "configureReport", component: ConfigureReport, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/testAppMenu/:applicationID", name: "testAppMenu", component: TestAppMenu, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/appTester/:applicationID", name: "appTester", component: AppTester, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/dashboard", name: "dashboarBoard", component: Dashboard, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/reportsStatistics", name: "reportsStatistics", component: ReportsStatistics, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/hubSystem", component: HubSystem, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/hubSystem/:hubid", component: ApplicationSystem, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/activities", component: Activities, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    path: "/application/:applicationID", component: ApplicationPage, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    path: "/activity/:activityID", component: AppUsuage, 
    meta: { requiresAuth: true, showFooter: false, showHeader: false }
  },
  { 
    path: "/activity/childView/:applicationID", component: ActivityChildView, 
    meta: { requiresAuth: false, showFooter: false, showHeader: false }
  },
  { 
    path: "/activity/report/:reportID", component: AppUsuageReport, 
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  { 
    name: "SpecialistPatientsStudents", path: "/specialistPatientsStudents", component: SpecialistPatientsStudents, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  { 
    name: "SpecialistGoals", path: "/specialistGoals", component: SpecialistGoals, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "Screening", path: "/specialistGoals/Screening", component: Screening, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "Assessment", path: "/specialistGoals/Assessment", component: Assessment, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "Intervention", path: "/specialistGoals/Intervention", component: Intervention, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "InterventionPlan", path: "/specialistInterventionPlan", component: InterventionPlan, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "SpecialistDashboards", path: "/specialistDashboards", component: SpecialistDashboards, props: true, 
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "SpecialistGoalsChildScreening", path: "/specialistGoals/Screening/:childID", component: SpecialistGoalsChildScreening, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true}
  },
  {
    name: "SpecialistDashboardInsights", path: "/specialistDashboard/insights", component: SpecialistDashboardInsights, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "SpecialistDashboardAnalytics", path: "/specialistDashboard/analytics", component: SpecialistDashboardAnalytics, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "DataPipelineTool", path: "/dataPipelineTool", component: DataPipelineTool,
    meta: { requiresAuth: true, showFooter: false, showHeader: true }
  },
  {
    name: "SpecialistStatisticsIndividual", path: "/specialistStatisticsIndividual/:childID", component: SpecialistStatisticsIndividual, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "SpecialistStatisticsAll", path: "/specialistStatisticsAll", component: SpecialistStatisticsAll,
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "OrganizationDashboardInsights", path: "/organizationDashboard/insights", component: OrganizationDashboardInsights, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "OrganizationDashboardAnalytics", path: "/organizationDashboard/analytics", component: OrganizationDashboardAnalytics, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "OrganizationSchools", path: "/schools", component: OrganizationSchools, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true }
  },
  {
    name: "OrganizationSpecialists", path: "/organizationSpecialists", component: OrganizationSpecialists, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "OrganizationSchoolsGraphs", path:"/schools/graphs/:orgID", component: OrganizationSchoolsGraphs, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "OrganizationIndividualSchool", path:"/schools/:orgID", component: OrganizationIndividualSchool, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "OrganizationIndividualSpecialist", path:"/organizationSpecialists/:specialistID", component: OrganizationIndividualSpecialist, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "OrganizationManagement", path:"/OrganizationManagement", component: OrganizationManagement, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  },
  {
    name: "Calendar", path:"/Calendar", component: Calendar, props: true,
    meta: { requiresAuth: true, showFooter: true, showHeader: true },
  }
];
